<template>
  <!-- compact: punto + palabra corta (listas angostas); el detalle va en el tooltip -->
  <span v-if="compact" class="monitor-report-chip monitor-report-chip--compact" :class="'monitor-report-chip--' + state"
        v-b-tooltip.hover.left="{ title: title, boundary: 'window' }">
    <span class="monitor-report-chip__dot"></span>
    <span>{{shortLabel}}</span>
  </span>
  <span v-else class="monitor-report-chip" :class="'monitor-report-chip--' + state" v-b-tooltip.hover :title="title">
    <AppIcon :name="icon" />
    <span>{{label}}</span>
  </span>
</template>

<script>
  import { reportState, timeAgo, formatDate, STALE_REPORT_MINUTES } from './monitorConfig'

  // estado del reporte de Monitor de un servidor o una instancia
  export default {
    props: {
      item: { type: Object, required: true },
      compact: { type: Boolean, default: false },
    },
    computed: {
      state() {
        return reportState(this.item)
      },
      icon() {
        return { pending: 'link_off', never: 'help', stale: 'schedule', ok: 'check_circle' }[this.state]
      },
      label() {
        if(this.state == 'pending') return 'Pendiente de emparejar'
        if(this.state == 'never') return 'Sin reportes'
        if(this.state == 'stale') return 'Atrasado · ' + timeAgo(this.item.monitor_reported_at)
        return timeAgo(this.item.monitor_reported_at)
      },
      shortLabel() {
        return { pending: 'Pendiente', never: 'Sin reportes', stale: 'Atrasado', ok: 'Al día' }[this.state]
      },
      title() {
        if(this.state == 'pending') return 'Monitor todavía no lo emparejó'
        if(this.state == 'never') return 'Emparejado, pero Monitor todavía no envió reportes'
        if(this.state == 'stale') return 'Atrasado ' + timeAgo(this.item.monitor_reported_at) + ' (sin reportes en los últimos ' + STALE_REPORT_MINUTES + ' minutos) · último: ' + formatDate(this.item.monitor_reported_at)
        return 'Al día · último reporte ' + timeAgo(this.item.monitor_reported_at) + ' (' + formatDate(this.item.monitor_reported_at) + ')'
      },
    },
  }
</script>

<style scoped>
  .monitor-report-chip {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 2px 8px;
    border: 1px solid transparent;
    border-radius: 999px;
    font-size: 12px;
    font-weight: 600;
    white-space: nowrap;
    max-width: 100%;
  }

  /* si el espacio no alcanza, el texto se parte en vez de desbordar */
  .monitor-report-chip span {
    min-width: 0;
    white-space: normal;
  }

  .monitor-report-chip--compact {
    gap: 5px;
    padding: 1px 8px;
    font-size: 11px;
  }

  .monitor-report-chip__dot {
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background: currentColor;
    flex: 0 0 7px;
  }

  .monitor-report-chip--ok {
    background: var(--app-color-success-soft, #e8f5e9);
    border-color: var(--app-color-success-border, #c3e6cb);
    color: var(--app-color-success, #28a745);
  }

  .monitor-report-chip--stale {
    background: var(--app-color-warning-soft, #fff8e1);
    border-color: var(--app-color-warning-border, #ffe08a);
    color: var(--app-color-warning-hover, #b8860b);
  }

  .monitor-report-chip--never {
    background: var(--app-color-surface-subtle, #f5f5f5);
    border-color: var(--app-color-border, #e3e6ea);
    color: var(--app-color-text-secondary, #6c757d);
  }

  .monitor-report-chip--pending {
    background: var(--app-color-primary-soft, #eaf2ff);
    border-color: var(--app-color-info-border, #b8daff);
    color: var(--app-color-primary-active, #0056b3);
  }
</style>
